import React, { useEffect, useState } from "react";

import Typography from "@/components/Typography";
import Container from "@/components/Container";

import styles from "./OfflineNotification.module.scss";

export const OfflineNotification: React.FC = () => {
  const [isVisible, setVisible] = useState<boolean>(false);
  const isClientSide = typeof window !== "undefined";
  const isOffline = isClientSide && !navigator.onLine;

  useEffect(() => {
    window.addEventListener("offline", () => {
      setVisible(true);
    });
    window.addEventListener("online", () => {
      setVisible(false);
    });

    return () => {
      window.removeEventListener("offline", () => {
        setVisible(true);
      });
      window.removeEventListener("online", () => {
        setVisible(false);
      });
    };
  }, []);

  return isVisible || isOffline ? (
    <div className={styles.wrapper}>
      <Container>
        <Typography variant="small" className={styles.text} component="p">
          Wygląda na to, że nie ma netu, więc nie wszystko będzie śmigać jak
          należy 😞
        </Typography>
      </Container>
    </div>
  ) : (
    <></>
  );
};

export default OfflineNotification;
